<template>
  <div class="awl-sidenav d-print-none" :class="{'w-auto is-collapsed': showIconsOnly}">
    <!-- Desktop Menu -->
    <div class="desktop-menu d-none d-md-flex flex-column justify-content-between h-100">
      <ul class="mb-lg-0" :class="{ 'overflow-auto' : !showIconsOnly }">
        <li v-for="(link, i) of links" :key="i">
          <AwlSidenavItem v-if="!link.hide" :link="link" :showIconsOnly="showIconsOnly" />
          <span v-else></span>
        </li>
      </ul>
      <div class="sidebar-footer">
        <ul class="mb-0">
          <li>
            <button class="btn btn-link text-white py-3 d-block w-100 text-left" @click="toggleSidebarState" :class="{'pl-4': !showIconsOnly}">
              <i class="icon rff-icon" :class="[ showIconsOnly ? 'icon-right-arrow' : 'icon-left-arrow' ]"></i>
              <span v-if="!showIconsOnly">
                Comprimi pannello
              </span>
            </button>
          </li>
          <li>
            <router-link @click.native="removeForecast" class="text-white py-3 d-block" :to="exitRoute" :class="{'pl-4': !showIconsOnly, 'text-center': showIconsOnly}">
              <i class="icon fas fa-sign-out-alt"></i>
              <span v-if="!showIconsOnly">
                Esci dall'azienda
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div class="mobile-menu d-flex d-md-none flex-column h-100">
      <div class="menu-items-wrapper d-flex">
        <ul class="menu-items-list my-4">
          <li v-for="(link, i) of links" :key="i">
            <div v-if="link.children && link.children.length > 0" class="mb-0">
              <!-- TODO: gestire apertura link da mobile -->
              <p class="link px-4 mb-0 py-3" @click="toggleChildren()">
                <i class="icon" :class="link.icon"></i>
                  {{ link.name }}
                <i class="ml-2 fa-xs fas fa-chevron-down text-white" :class="[ showChildrenLinks ? 'fa-chevron-down' : 'fa-chevron-right' ]"></i>
              </p>
              <ul v-if="showChildrenLinks" class="link-children pl-5">
                <li v-for="(child, i) in link.children" :key="i" class="fade-in" :style="{ animationDelay: i*.14 + 's' }">
                  <app-router-link v-if="child.appLink" :to="child.to" class="link px-1 py-2" v-close-menu>
                    {{ child.name }}
                  </app-router-link>
                  <router-link v-else :to="child.to" class="link px-1 py-2" v-close-menu>
                    {{ child.name }}
                  </router-link>
                </li>
              </ul>
            </div>

            <app-router-link v-else-if="link.to && link.appLink" :class="{ active: $route.name === link.to.name }" class="link px-4 py-3 d-block" :to="link.to" v-close-menu>
              <i class="icon" :class="link.icon"></i>
              {{ link.name }}
            </app-router-link>
            <router-link v-else-if="link.to" :class="{ active: $route.name === link.to.name }" class="link px-4 py-3 d-block" :to="link.to" v-close-menu>
              <i class="icon" :class="link.icon"></i>
              {{ link.name }}
            </router-link>
            <p v-else class="link px-4 mb-0 py-3">
              <i class="icon" :class="link.icon"></i>
              {{ link.name }}
            </p>
          </li>
          <li>
            <router-link @click.native="removeForecast" class="text-white py-3 pl-4 d-block" :to="exitRoute" v-close-menu>
              <i class="icon fas fa-sign-out-alt"></i>
              Esci dall'azienda
            </router-link>
          </li>
        </ul>
      </div>
      <ProfileSection />
    </div>
  </div>
</template>

<script>

import closeMenuDirective from '@/libs/Sidebar/directives/closeMenu.js';

export default {
  components: {
    AwlSidenavItem: () => import('./AwlSidenavItem.vue'),
    ProfileSection: () => import('@/views/components/Layout/ProfileSection/ProfileSection.vue'),
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink.vue'),
  },
  directives: {
    closeMenu: closeMenuDirective,
  },
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    showIconsOnly: function () {
      const companyId = this.$router?.currentRoute?.params?.id;
      localStorage.setItem(`showIconsOnly_${companyId}`, this.showIconsOnly);
    },
  },
  data () {
    return {
      collapseProfileSection: true,
      showIconsOnly: false,
      showChildrenLinks: false,
      user: null,
    };
  },
  computed: {
    myName () {
      return this.$oauth2?.me?.name;
    },
    showContextSelect () {
      return this.$oauth2.me && (this.$oauth2.me.companies?.length || 0) > 1;
    },
    exitRoute () {
      const me = this.$oauth2.me;

      if (me?.admin || me?.consultant) {
        return { name: 'management', replace: true };
      }

      if (me?.investor) {
        return { name: 'investors', replace: true };
      }

      if (me?.companies?.length > 1) {
        return { name: 'operative', replace: true };
      }

      return { name: 'logout' };
    },
  },
  methods: {
    toggleProfileSection () {
      this.collapseProfileSection = !this.collapseProfileSection;
    },
    toggleSidebarState () {
      this.showIconsOnly = !this.showIconsOnly;
    },
    beforeEnterProfile (el) {
      el.style.height = '0';
    },
    enterProfile (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeaveProfile (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leaveProfile (el) {
      el.style.height = '0';
    },
    logout () {
      this.$router.push({ name: 'logout' });
    },
    async profile () {
      try {
        const res = await this.$api.getMyProfile();
        this.user = res.data;
        this.$refs['profile-modal'].show();
      } catch (error) {
        this.$refs['error-modal'].show();
      }
    },
    changePassword () {
      this.$refs['change-password-modal'].show();
    },
    removeForecast () {
      if (!this.$appState.forecast) {
        return;
      }

      this.$appState.forecast = null;
    },
    setShowIconsOnly () {
      const companyId = this.$router?.currentRoute?.params?.id;
      this.showIconsOnly = (localStorage.getItem(`showIconsOnly_${companyId}`) === 'true');
    },
  },
  mounted () {
    this.setShowIconsOnly();
  },
};

</script>

<style lang="scss">

$primary: blue !default;
$white: #fff !default;
$sidebar-background-color: #eee !default;
$mobile-header-height: 60px !default;
$mobile-profile-section-height: 60px !default;

.fade-in {
  animation-duration: 1s;
  animation-name: fadeIn;
  animation-fill-mode: both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.awl-sidenav {
  background-color: $sidebar-background-color;
  box-shadow: 0 0 23px 3px rgba(0, 0, 0, .35);
  user-select: none;

  a, button:hover,
  a, button:active,
  a, button:focus {
    text-decoration: none !important;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  @include media-breakpoint-up("md") {
    box-shadow: none;
  }

  // Styles for mobile menu
  .mobile-menu {
    overflow-x: hidden;

    .menu-items-wrapper {
      margin-top: $mobile-header-height;
      margin-bottom: $mobile-profile-section-height;
    }

    .link {
      border-bottom-right-radius: 50px;
      border-top-right-radius: 50px;
      color: $white;
      &.active {
        background: $white;
        color: $primary;
      }
      .rff-icon {
        font-size: 28px;
        margin-right: 1rem;
      }
    }

    .link-children {
      .link {
        &.active {
          background: $primary;
          color: darken($color: $primary, $amount: 25%);
        }
      }
    }

    .menu-items-list {
        overflow-y: auto;
    }
  }

  // Styles for desktop menu
  .desktop-menu {
    width: inherit;

    .awl-sidenav--item {
      border: none;
      &:not(.active) {
        &:hover {
          background: lighten($color: $primary, $amount: 5%);
        }
      }

      // Style for Desktop Expanded Children Links
      .link-children {
        background: $primary;
        .link {
          color: $white;
          &.active {
            color: darken($color: $primary, $amount: 25%);
            font-weight: bold;
          }
        }
      }
    }

    .sidebar-footer {
      position: relative;
      background: #2084B8;
      text-transform: uppercase;
      font-size: 13px;
      line-height: 15px;
      font-weight: bold;
      padding-top: 9px;
      padding-bottom: 9px;

      .icon {
        margin-right: 10px;
      }

      .btn {
        text-transform: uppercase;
        font-size: 13px;
        line-height: 15px;
        font-weight: bold;

        &:active, &:focus {
          outline: none !important;
          box-shadow: none !important;
        }
      }

      &::after {
        $shadow-height: 25px;
        background: transparent;
        background: linear-gradient(180deg, rgba($primary,0) 0%, rgba($primary,1) 100%);;
        top: -($shadow-height + 1px);
        content: '';
        height: $shadow-height;
        left: 0;
        position: absolute;
        width: 100%;
        z-index: 999;
      }
    }
  }

  // Styles for collapsed sidebar
  &.is-collapsed {
    .desktop-menu {
      .menu-items-list {
        overflow-x: visible;
      }
      .awl-sidenav--item {
        border-color: transparent;
        transition: all .3s ease-in-out;
        border-left: 3px solid transparent;

        .awl-sidenav--link {
          height: 55px;
        }

        .hover-link-children {
            .list-header {
              align-items: center;
              display: flex;
              height: 55px;
            }
            .link-children {
              background: $white;
              .active {
                  color: darken($primary, 15%)!important;
                }
              }
            }

        &.active {
          background: darken($primary, 5%);
          border-left: 3px solid $white;
          color: $white;
          font-weight: bold;

          i {
            color: white;
          }
        }
      }
    }

    .sidebar-footer {
      .icon {
        margin-right: 0;
      }

      .btn {
        text-align: center !important;
      }

      li > * {
        align-items: center;
        display: flex;
        justify-content: center;
        height: 55px;
        width: 100%;
      }
    }
  }

}

</style>
